/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { CitationModule } from '@coursera-web/cds-labs';

import OnboardingModuleRenderer from 'bundles/front-page/redesign-modules/OnboardingModuleRenderer';
import CareerAcademyModuleRedesignModuleRenderer from 'bundles/front-page/redesign-modules/career-academy/CareerAcademyModuleRedesignModuleRenderer';
import CompactCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/compact-collections/CompactCollectionsModuleRenderer';
import {
  getPopularAndTrendingCollectionData,
  getPopularByCategoryCollectionData,
} from 'bundles/front-page/redesign-modules/compact-collections/data/getCompactCollections';
import DomainsModuleRenderer from 'bundles/front-page/redesign-modules/domains/DomainsModuleRenderer';
import HeroBannerModuleRenderer from 'bundles/front-page/redesign-modules/hero-banner/HeroBannerModuleRenderer';
import MerchandisingBucketsModuleRenderer from 'bundles/front-page/redesign-modules/merchandising-buckets/MerchandisingBucketsModuleRenderer';
import PartnerLogosModuleRenderer from 'bundles/front-page/redesign-modules/partner-logos/PartnerLogosModuleRenderer';
import PromoUnitsModuleRenderer from 'bundles/front-page/redesign-modules/promo-units/PromoUnitsModuleRenderer';
import SpotlightCollectionsModuleRenderer from 'bundles/front-page/redesign-modules/spotlight-collections/SpotlightCollectionsModuleRenderer';
import TestimonialsModuleRedesignRenderer from 'bundles/front-page/redesign-modules/testimonials/TestimonialsModuleRedesignRenderer';
import getCertificationPrepSpotlightCollectionsData from 'bundles/front-page/utils/getCertificationPrepSpotlightCollections';
import getNewReleasesSpotlightCollectionsData from 'bundles/front-page/utils/getNewReleasesSpotlightCollections';
import { getPathwayDisclaimer } from 'bundles/unified-common/utils/getPathwaysDisclaimers';

const styles = {
  container: css`
    margin-top: var(--cds-spacing-200);
  `,
};

// Page content of LOHP Redesign Q3 2025
const FrontPageContent = () => {
  return (
    <div css={styles.container}>
      <HeroBannerModuleRenderer />
      <MerchandisingBucketsModuleRenderer />
      <PartnerLogosModuleRenderer />
      <CompactCollectionsModuleRenderer {...getPopularAndTrendingCollectionData()} />
      <DomainsModuleRenderer />
      <SpotlightCollectionsModuleRenderer {...getNewReleasesSpotlightCollectionsData()} />
      <CareerAcademyModuleRedesignModuleRenderer />
      <OnboardingModuleRenderer />
      <SpotlightCollectionsModuleRenderer {...getCertificationPrepSpotlightCollectionsData()} />
      <CompactCollectionsModuleRenderer {...getPopularByCategoryCollectionData()} />
      <PromoUnitsModuleRenderer />
      <TestimonialsModuleRedesignRenderer />
      <CitationModule citations={getPathwayDisclaimer()} removeBottomPadding />
    </div>
  );
};

export default FrontPageContent;
